import React, { useRef } from "react";

const TextArea = React.forwardRef((props, ref) => {
    const {
        value = "",
        width = 0,
        height = 200,
        className = "",
        secondary = false,
        warning = false,
        style = {},
        right = false,
        medium,
        edit = false,
        placeholder = "",
        onChange = () => { },
        onFocus = () => { },
        onClick = () => { },
        controlled = false,
        autoselect = false
    } = props;

    const didFocus = useRef(false);

    let _class = (edit) ? "ui-input edit" : "ui-input";
    if (secondary) { _class += " secondary"; }
    if (warning) { _class += " warning"; }
    if (className) { _class += " " + className; }
    if (right) { _class += " ra"; }
    if (width) { style.width = width + "px"; }
    if (medium) { _class += " medium"; }

       const change = (_v) => {
            onChange(_v);
        };


    if (edit) {
        return (
            <textarea

                onClick={(e) => {
                    if (!didFocus.current) {
                        didFocus.current = true;
                        if (autoselect) e.target.select();
                        onFocus();
                    }
                }}
                onBlur={() => {
                    didFocus.current = false;
                }}
                onChange={(e) => change(e.target.value)}
                ref={ref}
                placeholder={placeholder}
                style={{ ...style, "height": height + "px" }}
                className={_class}
                {...(controlled ? { value } : { defaultValue: value })}
            />
        )
    }

    return <div onClick={() => onClick()} style={{ ...style }} className={_class}>{value}</div>;
});

export default TextArea;
